import { DIALOG_BLUE_BUTTON } from '../modals/constants';
import { roundRect } from '../renderers';
import { lineFont } from '../state';
import { BasicObject } from '../uiObjects/basicObject';

import { LABEL_FONT_SIZE, LABEL_RECT_RADIUS } from './SectionedHelpConstants';

export const BORDER_WIDTH = 4;
const BORDER_COLOR = 'green';
const BORDER_COLOR_ALSO_ACCEPTS = DIALOG_BLUE_BUTTON;
const TEXT_PADDING = 2;

const getHelpAnswerRegionLabel = (
  answerIndex?: number,
  acceptsOtherForms?: boolean
): string => {
  if (acceptsOtherForms) {
    return 'Also Accepted';
  }

  return answerIndex !== undefined ? `Answer ${answerIndex}` : 'Answer';
};

export const getHelpAnswerRegionLabelMetrics = (
  ctx: CanvasRenderingContext2D,
  answerIndex?: number,
  acceptsOtherForms?: boolean
): { label: string; labelBoxWidth: number; outerWidth: number } => {
  const label = getHelpAnswerRegionLabel(answerIndex, acceptsOtherForms);

  ctx.save();
  ctx.font = `${LABEL_FONT_SIZE}px ${lineFont}`;
  const textWidth = ctx.measureText(label).width;

  ctx.restore();

  const labelBoxWidth = textWidth + 2 * BORDER_WIDTH;

  return {
    label,
    labelBoxWidth,
    outerWidth: labelBoxWidth + BORDER_WIDTH,
  };
};

export class HelpAnswerRegion extends BasicObject {
  answerIndex?: number;
  acceptsOtherForms?: boolean;

  constructor(
    y: number,
    width: number,
    height: number,
    answerIndex?: number,
    acceptsOtherForms?: boolean
  ) {
    super();
    this.gmmName = 'helpAnswerRegion';
    this.viewportY = y;
    this.viewportW = width;
    this.viewportH = height;
    this.answerIndex = answerIndex;
    this.acceptsOtherForms = acceptsOtherForms;
  }

  paintMe(ctx: CanvasRenderingContext2D): void {
    ctx.save();
    const { label, labelBoxWidth } = getHelpAnswerRegionLabelMetrics(
      ctx,
      this.answerIndex,
      this.acceptsOtherForms
    );

    if (this.acceptsOtherForms) {
      // Set fill style to alternate color for the rectangle for "also accepts" cells
      ctx.fillStyle = BORDER_COLOR_ALSO_ACCEPTS;
      ctx.strokeStyle = BORDER_COLOR_ALSO_ACCEPTS;
    } else {
      // Set fill style to green for the rectangle
      ctx.fillStyle = BORDER_COLOR;
      ctx.strokeStyle = BORDER_COLOR;
    }

    // Draw a rounded rectangular border around the answer
    ctx.lineWidth = BORDER_WIDTH;
    ctx.beginPath();
    roundRect(
      ctx,
      BORDER_WIDTH / 2,
      BORDER_WIDTH / 2,
      this.viewportW - BORDER_WIDTH,
      this.viewportH - BORDER_WIDTH,
      LABEL_RECT_RADIUS
    );
    ctx.stroke();

    // Draw a filled rounded rectangle at the top-left corner
    ctx.beginPath();
    roundRect(
      ctx,
      BORDER_WIDTH / 2,
      BORDER_WIDTH / 2,
      labelBoxWidth,
      LABEL_FONT_SIZE + BORDER_WIDTH,
      LABEL_RECT_RADIUS / 2
    );
    ctx.fill();
    ctx.stroke();

    // Set fill style to white and add the text in the filled rectangle
    ctx.font = `${LABEL_FONT_SIZE}px ${lineFont}`;
    ctx.fillStyle = 'white';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillText(label, BORDER_WIDTH + TEXT_PADDING, BORDER_WIDTH);
    ctx.restore();
  }
}
